import { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import { useAnalytics } from '@/hooks/analytics';
import genericMessages from '@/messages/messages';
import BackArrow from 'icons/back-arrow.svg';

import { OnDTCScreenChange } from '../shared/types';
import { BackButton, BackButtonText } from './styles';

interface Props {
	onScreenChange: OnDTCScreenChange;
}

export default function Back({ onScreenChange }: Props): ReactElement {
	const { logEvent } = useAnalytics();
	const { formatMessage } = useIntl();

	function onBackClick(): void {
		logEvent({ eventName: 'Account : Back : Clicked' });
		onScreenChange('welcome');
	}

	return (
		<BackButton onClick={onBackClick}>
			<BackArrow />
			<BackButtonText>{formatMessage(genericMessages.back)}</BackButtonText>
		</BackButton>
	);
}
